import Skeleton from "react-loading-skeleton"

const InfluencerCollaborationInsightSkeleton: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    return (
        <div>
            <div className="menu-title">
                <div className="d-flex flex-row align-items-center m-2 mt-4">
                    <Skeleton
                        circle
                        style={{ height: 60, width: 60 }}
                    />
                    <div className="ms-3">
                        <Skeleton width={150} />
                        <Skeleton width={70} />
                        <Skeleton width={70} />
                        <button className="close-menu mt-n5" onClick={e => onClose()}>
                            <i className="fa fa-times-circle"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div className="content">
                <Skeleton width={'100%'} height={50} />
                <div className="mt-4">
                    <Skeleton width={'100%'} height={30} />
                    <Skeleton count={3} width={'100%'} containerClassName="mt-3" />
                </div>

                <div className="mt-4">
                    <Skeleton width={'100%'} height={30} />
                    <Skeleton count={3} width={'100%'} containerClassName="mt-3" />
                </div>

                <div className="mt-4 d-flex justify-content-between align-items-center">
                    <Skeleton width={'100px'} height={100} />
                    <div className="w-100 ms-2">
                        <Skeleton count={3} width={'100%'} containerClassName="mt-3" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InfluencerCollaborationInsightSkeleton